import { FormLabel, Grid, Input, TextField } from "@mui/material";


export const ViewAndEditEntity = ({
  
    handleInputChange,
    index,
    row,
    viewMode,
    validationStatus,
}) => {
    //inline style
    const InlineStyle = {
        EntityDivison: {
            width: "230px", height: "32", padding: "0px"
        },
    }
    return (
      <form>
        <Grid container justifyContent={"space-between"}>
          <Grid
            item
            xs={5}
            display={"flex"}
            flexDirection={"column"}
            gap={"5px"}
            mt={"20px"}
          >
            <FormLabel>Month</FormLabel>
            <Input
                    type="date"
                    value={row?.month?.substring(0, 10) ?? ""}
                    onChange={(e) =>
                      handleInputChange(index, "month", e.target.value)
                    }
                    style={InlineStyle.PaymentReceiveDate}
                    placeholder="Enter Details Here"
                    disabled={viewMode}
                  />
            <br />
            {validationStatus[index]?.month && (
              <span style={{ color: "red" }}>
                {validationStatus[index]?.month}
              </span>
            )}
          </Grid>
          <Grid
            item
            xs={5}
            display={"flex"}
            flexDirection={"column"}
            gap={"5px"}
            mt={"20px"}
          >
            <FormLabel>Currency Code</FormLabel>
            <TextField
              value={row.currency_code}
              onChange={(e) =>
                handleInputChange(index, "currency_code", e.target.value)
              }
              sx={InlineStyle.EntityDivison}
              size="small"
              placeholder="Enter Details Here"
              disabled={viewMode}
            />
            <br />
            {validationStatus[index]?.currency_code && (
              <span style={{ color: "red" }}>
                {validationStatus[index]?.currency_code}
              </span>
            )}
          </Grid>
          <Grid
            item
            xs={8}
            display={"flex"}
            flexDirection={"column"}
            gap={"5px"}
            mt={"20px"}
          >
            <FormLabel>Exchange Rate</FormLabel>
            <TextField
              value={row.exchange_rate}
              onChange={(e) =>
                handleInputChange(index, "exchange_rate", e.target.value)
              }
              sx={InlineStyle.EntityDivison}
              size="small"
              placeholder="Enter Details Here"
              disabled={viewMode}
              type="number"
            />
            <br />
            {validationStatus[index]?.exchange_rate && (
              <span style={{ color: "red" }}>
                {validationStatus[index]?.exchange_rate}
              </span>
            )}
          </Grid>
      
        </Grid>
      </form>
    );
}